module.exports = __webpack_public_path__ + "img/7_george_n.e7bac383.png";